import {
  GET_PASSWORDS_URL,
  GET_PASSWORD_DETAIL_URL,
  VIEW_PASSWORD_URL,
  GET_PASSWORD_REFERENCE_URL
} from '../../constants/ApiUri';
import {
  Passwords,
  PasswordDetailData,
  PasswordRefResponse,
  PasswordRefFilterState
} from '../../types/resources/State';
import {
  ViewPasswordRequest,
  ViewPasswordResponse
} from '../../types/resources/Password';

import { Http, safeJsonParse } from 'vrlcm-gui-utils';

export default class PasswordAPI {
  public static getPasswords = (payload?: {
    currentPage: number;
    pageSize: number;
    filter: string;
  }): Promise<Passwords> => {
    const currentPage = payload ? payload.currentPage : 0;
    const pageSize = payload ? payload.pageSize : 10;
    const filter = payload ? encodeURIComponent(payload.filter) : '';
    return Http.get(GET_PASSWORDS_URL(currentPage, pageSize, filter)).then(
      res => res.data
    );
  };

  public static getPasswordDetail = (
    passwordId: string
  ): Promise<PasswordDetailData> => {
    return Http.get(GET_PASSWORD_DETAIL_URL(passwordId)).then(res => res.data);
  };

  public static getPasswordReferences = (payload?: {
    refType: string;
    passwordVMID: string;
    currentPage: number;
    pageSize: number;
    filter?: PasswordRefFilterState;
  }): Promise<PasswordRefResponse> => {
    const currentPage = payload ? payload.currentPage : 0;
    const pageSize = payload ? payload.pageSize : 2;
    const refType = payload ? payload.refType : '';
    const passwordVMID = payload ? payload.passwordVMID : '';
    const filter = payload ? payload.filter : undefined;

    return Http.get(
      GET_PASSWORD_REFERENCE_URL(
        passwordVMID,
        currentPage,
        pageSize,
        refType,
        filter
      )
    ).then(res => {
      res.data.references = res.data.references.map((itm: any) => {
        itm.meta = safeJsonParse(itm.meta);
        if (itm.meta.inventoryOnly) {
          itm.meta.inventoryOnly = itm.meta.inventoryOnly === 'true';
        }
        return itm;
      });
      return res.data;
    });
  };

  public static viewPassword = async (
    vmid: string,
    requestData: ViewPasswordRequest
  ): Promise<ViewPasswordResponse> => {
    const response = await Http.post<ViewPasswordResponse>(
      VIEW_PASSWORD_URL(vmid),
      requestData
    );
    return response.data;
  };
}
